import React, { FormEvent, useState } from "react";
// Redux
import { useDispatch } from "react-redux";
// UI Components
import { ErrorLoader } from "../../../../UI/Loaders/Loaders";
import { hideModal } from "../../../../redux/actions/modal";
import { setAdvancedAuditTrailSearchParams } from "../../../../redux/actions/auditTrail";
import { IAuditTrailSearchParams } from "../../../../interfaces/auditTrail";
import CustomSelectDropdown from "../../../../components/CustomHTMLElements/CustomSelectDropdown";
import useAuditTrailTypes from "../../../../custom-hooks/useAuditTrailTypes";
import useAuditTrailEntityTypes from "../../../../custom-hooks/useAuditTrailEntityTypes";
import { message } from "antd";
import CustomSearchDropDown from "../../../../components/CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";

const today = new Date().toISOString().slice(0, 10);
const lastMonth = new Date(new Date());
lastMonth.setDate(lastMonth.getDate() - 30);
const aMonthAgo = lastMonth.toISOString().slice(0, 10);

const AdvanceAuditTrailSearchModal = ({ onCloseModal, dataRecord }: any) => {
  const [state, setState] = useState<IAuditTrailSearchParams>({
    start_date: aMonthAgo,
    end_date: today,
  });

  const dispatch = useDispatch();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const diffTime =
      new Date(state?.end_date!).valueOf() -
      new Date(state?.start_date!).valueOf();

    if (diffTime < 0) {
      message.info("Invalid date range");
      return;
    }

    dispatch(setAdvancedAuditTrailSearchParams({ ...state }!));
    dispatch(hideModal());
  };

  const { data: auditTrailTypesData } = useAuditTrailTypes();
  const { data: auditTrailEntityTypes } = useAuditTrailEntityTypes();

  const handleAuditTypeChange = (data: { label: string; value: number }) => {
    setState((prev) => {
      return {
        ...prev!,
        audit_type_id: String(data?.value),
      };
    });
  };

  const handleEntityTypeChange = (data: { label: string; value: number }) => {
    setState((prev) => {
      return {
        ...prev!,
        entity_name: String(data?.value),
      };
    });
  };

  const getDefaultOptions = <T extends { name: string; id: number }>(
    items: T[] | undefined
  ) => {
    if (!items) return [];
    return items.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  };

  const getDefaultEntityOptions = (_entityTypes: string[]) => {
    if (!_entityTypes) return [];
    return _entityTypes.map((item) => ({
      label: item,
      value: item,
    }));
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1">Search By:</h3>
            {/* 2. Confirm Update Role ModalContainer*/}
            <div id="disbursement-confirm">
              <div className="m-b-30">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="table-fetch">RC Number:</label>
                      <input
                        type="text"
                        placeholder="e.g. 346782"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => {
                            return {
                              ...prev!,
                              rc_number: e.target.value,
                            };
                          });
                        }}
                        name="rc_number"
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="table-fetch">BVN:</label>
                      <input
                        type="text"
                        placeholder="e.g. 231749468790"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => {
                            return {
                              ...prev!,
                              bvn: e.target.value,
                            };
                          });
                        }}
                        name="bvn"
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="table-fetch">User Email:</label>
                      <input
                        type="text"
                        placeholder="e.g. john_doe@nomail.com"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => {
                            return {
                              ...prev!,
                              user_name: e.target.value,
                            };
                          });
                        }}
                        name="user_name"
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 mt-4">
                      <div className="input-group pt-1">
                        <CustomSearchDropDown
                          label="Audit Type:"
                          onChange={handleAuditTypeChange}
                          options={getDefaultOptions(
                            auditTrailTypesData?.data!
                          )}
                          name="user"
                          isShowLabel
                          inputHeight={50}
                          isAsync={false}
                          labelStyle={{
                            fontSize: "12rem",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-4">
                      <div className="input-group pt-1">
                        <CustomSearchDropDown
                          label="Entity Type:"
                          onChange={handleEntityTypeChange}
                          options={getDefaultEntityOptions(
                            auditTrailEntityTypes?.data!
                          )}
                          name="user"
                          isShowLabel
                          inputHeight={50}
                          isAsync={false}
                          labelStyle={{
                            fontSize: "12rem",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-4">
                      <label htmlFor="table-fetch">From:</label>
                      <input
                        type="date"
                        value={state.start_date}
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => {
                            return {
                              ...prev!,
                              start_date: e.target.value,
                            };
                          });
                        }}
                        name="startDate"
                        placeholder="YYYY/MM/DD"
                      />
                    </div>

                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="table-fetch">To:</label>
                      <input
                        type="date"
                        value={state.end_date}
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => {
                            return {
                              ...prev!,
                              end_date: e.target.value,
                            };
                          });
                        }}
                        name="endDate"
                        placeholder="YYYY/MM/DD"
                      />
                    </div>
                  </div>
                  <div className="Form__action-buttons m-t-2">
                    <button
                      type="submit"
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                    >
                      <i className="fa fa-check-circle" /> Search
                    </button>
                    {/* <button
                      id="create"
                      data-id="create-role"
                      data-action="create"
                      className="create zoom-element btn login-btn"
                      // onClick={getLoanRecordsModal}
                    >
                      <i className="fas fa-download" /> &nbsp; Download
                    </button> */}
                    <button
                      type="button"
                      onClick={() => {
                        dispatch(setAdvancedAuditTrailSearchParams({}));
                        onCloseModal();
                      }}
                      className="btn zoom-element btn login-btn m-0 ml-auto"
                    >
                      <i className="fa fa-times-circle" /> Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* 2. Disbursement Loader*/}
            <div
              id="disbursement-loader"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className=" form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading" id="adv-loader-alt" />
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier fas fa-user-cog" />
                    Searching ...
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Disbursement Success Message*/}
            <div
              id="disbursement-success"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading success-loader">
                    <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                  </div>
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier far fa-check-circle" />
                    Search Successful
                  </div>
                </div>
              </div>
            </div>

            {/* 4. Disbursement Error */}
            <div
              id="disbursement-error"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <ErrorLoader
                icon="fas fa-wifi"
                text="Network Issue"
                subText="Unable to connect to Advancly services."
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default AdvanceAuditTrailSearchModal;
